;(function () {
	"use strict";

	/**
	 * Publish the rendered header height as a CSS variable.
	 * Blocks can then allow for the header height when calculating their own height.
	 */
	function HeaderHeight() {
		var global = {
			header: document.querySelector('.header'),
			root: document.documentElement,
		};

		var fn = {
			init: function () {
				if (!global.header) {
					return;
				}

				// Recalculate when viewport/ header layout changes
				fn.setHeaderHeightProperty();
				window.addEventListener('load', fn.setHeaderHeightProperty);
				window.addEventListener('resize', fn.setHeaderHeightProperty);

				if (window.ResizeObserver) {
					new ResizeObserver(fn.setHeaderHeightProperty).observe(global.header);
				}
			},

			setHeaderHeightProperty: function () {
				global.root.style.setProperty('--site-header-height', global.header.getBoundingClientRect().height + 'px');
			},
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn.init);
		}
		else {
			fn.init();
		}
	}

	new HeaderHeight();
})();